import { render, staticRenderFns } from "./support.vue?vue&type=template&id=95790aa6&"
import script from "./support.vue?vue&type=script&lang=ts&"
export * from "./support.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports